'use client';

import React, { createContext, useContext, useMemo } from 'react';

import { LogoName } from '../components/ui';

export interface CobrandedContextValue {
  logoName?: LogoName;
}

const CobrandedContext = createContext<CobrandedContextValue>({});

export const useCobranded = () => useContext(CobrandedContext);

export const CobrandedProvider: React.FC<{
  readonly logoName?: LogoName;
  readonly children: React.ReactNode;
}> = ({ logoName, children }) => {
  const value = useMemo(() => ({ logoName }), [logoName]);
  return (
    <CobrandedContext.Provider value={value}>
      {children}
    </CobrandedContext.Provider>
  );
};
